import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { UscHomeComponent } from './usc-home.component';
//import { HomeAuthResolver } from './home-auth-resolver.service';
import { SharedModule } from '../../../shared.module';

const uscHomeRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'usc-store/home',
    component: UscHomeComponent,
    outlet: 'usc_store'
    // resolve: {
    //   isAuthenticated: HomeAuthResolver
    // }
  }
]);

@NgModule({
  imports: [
    // NgbDropdownModule.forRoot(),
    uscHomeRouting, 
    SharedModule,
  ],
  declarations: [
    UscHomeComponent
  ],
  providers: [
    //HomeAuthResolver
  ]
})

export class UscHomeModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-home/usc-home.module.ts